module.exports = __webpack_public_path__ + "static/media/pc.6d445a8d.png";